import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import './CalendarTasksPage.css';

function CalendarTasksPage() {
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => { document.title = 'PEC - Calendario'; }, []);
  const [activeView, setActiveView] = useState('day'); // 'day', 'week', 'month'
  // eslint-disable-next-line no-unused-vars
  const [selectedDate, setSelectedDate] = useState(new Date());

  // Mock data for calendar events - you can replace with real API data
  const calendarEvents = [
    {
      id: 1,
      title: 'Reunión de Equipo - Sprint Planning',
      description: 'Planificación del próximo sprint con el equipo de desarrollo. Revisar backlog y definir objetivos.',
      startTime: '2024-01-15T09:00:00Z',
      endTime: '2024-01-15T10:30:00Z',
      type: 'meeting',
      priority: 'high',
      attendees: ['Ana García', 'Carlos López', 'María Rodríguez'],
      location: 'Sala de Reuniones A',
      tags: ['trabajo', 'desarrollo', 'sprint', 'equipo'],
      status: 'confirmed',
      color: 'blue',
      recurrence: 'weekly'
    },
    {
      id: 2,
      title: 'Cita Médica - Chequeo General',
      description: 'Revisión médica anual. Análisis de sangre y revisión general de salud.',
      startTime: '2024-01-15T14:00:00Z',
      endTime: '2024-01-15T15:00:00Z',
      type: 'appointment',
      priority: 'high',
      attendees: ['Dr. Juan Martínez'],
      location: 'Hospital Central',
      tags: ['salud', 'médico', 'chequeo'],
      status: 'confirmed',
      color: 'red',
      recurrence: 'yearly'
    },
    {
      id: 3,
      title: 'Sesión de Ejercicio - Gimnasio',
      description: 'Rutina de entrenamiento de fuerza y cardio. Enfoque en grupo muscular superior.',
      startTime: '2024-01-15T18:00:00Z',
      endTime: '2024-01-15T19:30:00Z',
      type: 'personal',
      priority: 'medium',
      attendees: [],
      location: 'PowerGym Centro',
      tags: ['ejercicio', 'salud', 'rutina', 'gimnasio'],
      status: 'confirmed',
      color: 'green',
      recurrence: 'daily'
    },
    {
      id: 4,
      title: 'Webinar: IA en el Desarrollo de Software',
      description: 'Conferencia online sobre las últimas tendencias en inteligencia artificial aplicada al desarrollo.',
      startTime: '2024-01-16T16:00:00Z',
      endTime: '2024-01-16T17:30:00Z',
      type: 'learning',
      priority: 'medium',
      attendees: ['500+ participantes'],
      location: 'Online - Zoom',
      tags: ['educación', 'IA', 'desarrollo', 'webinar'],
      status: 'confirmed',
      color: 'purple',
      recurrence: 'none'
    },
    {
      id: 5,
      title: 'Almuerzo con Cliente - Proyecto Web',
      description: 'Reunión con cliente para discutir requerimientos del nuevo proyecto de e-commerce.',
      startTime: '2024-01-16T13:00:00Z',
      endTime: '2024-01-16T14:30:00Z',
      type: 'business',
      priority: 'high',
      attendees: ['Roberto Silva', 'Elena Vega'],
      location: 'Restaurante El Mirador',
      tags: ['cliente', 'proyecto', 'negocios', 'almuerzo'],
      status: 'tentative',
      color: 'orange',
      recurrence: 'none'
    },
    {
      id: 6,
      title: 'Tiempo Personal - Lectura',
      description: 'Tiempo dedicado a la lectura del libro "Atomic Habits" de James Clear.',
      startTime: '2024-01-16T20:00:00Z',
      endTime: '2024-01-16T21:00:00Z',
      type: 'personal',
      priority: 'low',
      attendees: [],
      location: 'Casa - Estudio',
      tags: ['lectura', 'desarrollo-personal', 'hábitos'],
      status: 'confirmed',
      color: 'cyan',
      recurrence: 'daily'
    },
    {
      id: 7,
      title: 'Presentación a Inversionistas',
      description: 'Pitch de 20 minutos para presentar la startup a potenciales inversionistas.',
      startTime: '2024-01-17T10:00:00Z',
      endTime: '2024-01-17T11:00:00Z',
      type: 'business',
      priority: 'high',
      attendees: ['3 Inversionistas', 'Socio Fundador'],
      location: 'Oficina Principal',
      tags: ['startup', 'inversionistas', 'pitch', 'negocios'],
      status: 'confirmed',
      color: 'red',
      recurrence: 'none'
    },
    {
      id: 8,
      title: 'Curso Online - React Avanzado',
      description: 'Módulo 5: Optimización de performance en aplicaciones React a gran escala.',
      startTime: '2024-01-17T19:00:00Z',
      endTime: '2024-01-17T20:30:00Z',
      type: 'learning',
      priority: 'medium',
      attendees: [],
      location: 'Online - Udemy',
      tags: ['programación', 'react', 'curso', 'desarrollo'],
      status: 'confirmed',
      color: 'blue',
      recurrence: 'weekly'
    }
  ];

  // Filter events based on search term and selected date
  const filteredEvents = calendarEvents.filter(event => {
    const matchesSearch = event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         event.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         event.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         event.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    
    // For simplicity, showing all events (in real app, filter by date)
    return matchesSearch;
  });

  // Calculate stats
  const totalEvents = calendarEvents.length;
  const todayEvents = calendarEvents.filter(event => {
    const eventDate = new Date(event.startTime).toDateString();
    const today = new Date().toDateString();
    return eventDate === today;
  }).length;
  const upcomingEvents = calendarEvents.filter(event => {
    const eventDate = new Date(event.startTime);
    const now = new Date();
    return eventDate > now;
  }).length;
  const highPriorityEvents = calendarEvents.filter(event => event.priority === 'high').length;

  const handleEventAction = (eventId, action) => {
    console.log(`${action} event:`, eventId);
    // Implement event action functionality
  };

  const handleAddEvent = () => {
    console.log('Adding new event');
    // Implement add event functionality
  };

  const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatDate = (dateString) => {
    const eventDate = new Date(dateString);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    if (eventDate.toDateString() === today.toDateString()) return 'Hoy';
    if (eventDate.toDateString() === tomorrow.toDateString()) return 'Mañana';
    
    const diffTime = eventDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays > 0 && diffDays <= 7) return `En ${diffDays} días`;
    if (diffDays < 0 && diffDays >= -7) return `Hace ${Math.abs(diffDays)} días`;
    
    return eventDate.toLocaleDateString('es-ES', { 
      weekday: 'short', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const getDuration = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const diffMs = end - start;
    const diffHours = diffMs / (1000 * 60 * 60);
    
    if (diffHours < 1) {
      const diffMinutes = diffMs / (1000 * 60);
      return `${Math.round(diffMinutes)} min`;
    }
    
    return `${diffHours.toFixed(1)} h`;
  };

  const getEventTypeIcon = (type) => {
    const icons = {
      'meeting': '👥',
      'appointment': '🏥',
      'personal': '🧘',
      'learning': '📚',
      'business': '💼'
    };
    return icons[type] || '📅';
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'red';
      case 'medium': return 'orange';
      case 'low': return 'gray';
      default: return 'gray';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed': return 'green';
      case 'tentative': return 'orange';
      case 'cancelled': return 'red';
      default: return 'gray';
    }
  };

  return (
    <div className="calendar-page">
      <Header 
        currentPage="calendar" 
        showSearch 
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        showAddButton 
        onAddNew={handleAddEvent}
      />

      <div className="calendar-content">
        {/* Calendar Stats */}
        <div className="calendar-stats">
          <div className="stat-card total">
            <div className="stat-icon">📊</div>
            <div className="stat-content">
              <h3>{totalEvents}</h3>
              <p>Total de Eventos</p>
            </div>
          </div>
          <div className="stat-card today">
            <div className="stat-icon">📅</div>
            <div className="stat-content">
              <h3>{todayEvents}</h3>
              <p>Eventos de Hoy</p>
            </div>
          </div>
          <div className="stat-card upcoming">
            <div className="stat-icon">⏰</div>
            <div className="stat-content">
              <h3>{upcomingEvents}</h3>
              <p>Próximos Eventos</p>
            </div>
          </div>
          <div className="stat-card priority">
            <div className="stat-icon">🔥</div>
            <div className="stat-content">
              <h3>{highPriorityEvents}</h3>
              <p>Alta Prioridad</p>
            </div>
          </div>
        </div>

        {/* Calendar Views */}
        <div className="calendar-views">
          <div className="view-tabs">
            <button 
              className={`view-tab ${activeView === 'day' ? 'active' : ''}`}
              onClick={() => setActiveView('day')}
            >
              📋 Día
            </button>
            <button 
              className={`view-tab ${activeView === 'week' ? 'active' : ''}`}
              onClick={() => setActiveView('week')}
            >
              📆 Semana
            </button>
            <button 
              className={`view-tab ${activeView === 'month' ? 'active' : ''}`}
              onClick={() => setActiveView('month')}
            >
              🗓️ Mes
            </button>
          </div>
          <div className="view-actions">
            <button className="btn-secondary">Sincronizar</button>
            <button className="btn-secondary">Exportar</button>
            <button className="btn-secondary">Configurar</button>
          </div>
        </div>

        {/* Events List */}
        <div className="events-section">
          <div className="section-header">
            <h2>Eventos Programados ({filteredEvents.length})</h2>
            <div className="timeline-indicator">
              <span className="current-time">⏰ {new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}</span>
            </div>
          </div>

          <div className="events-list">
            {filteredEvents.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">📅</div>
                <h3>No se encontraron eventos</h3>
                <p>Intenta ajustar los términos de búsqueda o agregar un nuevo evento</p>
              </div>
            ) : (
              filteredEvents.map((event) => (
                <div key={event.id} className={`event-card ${event.type} ${event.color}`}>
                  <div className="event-header">
                    <div className="event-time-block">
                      <div className="event-date">{formatDate(event.startTime)}</div>
                      <div className="event-time">
                        {formatTime(event.startTime)} - {formatTime(event.endTime)}
                      </div>
                      <div className="event-duration">{getDuration(event.startTime, event.endTime)}</div>
                    </div>
                    <div className="event-meta">
                      <div className="event-title-row">
                        <div className="event-type-icon">{getEventTypeIcon(event.type)}</div>
                        <h4 className="event-title">{event.title}</h4>
                        <div className="event-badges">
                          <div className={`priority-badge ${getPriorityColor(event.priority)}`}>
                            {event.priority.toUpperCase()}
                          </div>
                          <div className={`status-badge ${getStatusColor(event.status)}`}>
                            {event.status.toUpperCase()}
                          </div>
                        </div>
                      </div>
                      <p className="event-description">{event.description}</p>
                      <div className="event-details">
                        <span className="event-location">📍 {event.location}</span>
                        {event.attendees.length > 0 && (
                          <span className="event-attendees">
                            👥 {event.attendees.length > 2 
                              ? `${event.attendees.slice(0, 2).join(', ')} +${event.attendees.length - 2} más`
                              : event.attendees.join(', ')
                            }
                          </span>
                        )}
                        {event.recurrence !== 'none' && (
                          <span className="event-recurrence">🔄 {event.recurrence}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  <div className="event-body">
                    <div className="event-tags">
                      {event.tags.map((tag, index) => (
                        <span key={index} className="event-tag">
                          #{tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="event-actions">
                    <button 
                      className="btn-action primary"
                      onClick={() => handleEventAction(event.id, 'view')}
                    >
                      Ver Detalles
                    </button>
                    <button 
                      className="btn-action secondary"
                      onClick={() => handleEventAction(event.id, 'edit')}
                    >
                      Editar
                    </button>
                    <button 
                      className="btn-action secondary"
                      onClick={() => handleEventAction(event.id, 'duplicate')}
                    >
                      Duplicar
                    </button>
                    <button 
                      className="btn-action secondary"
                      onClick={() => handleEventAction(event.id, 'join')}
                    >
                      🔗 Unirse
                    </button>
                    <button 
                      className="btn-action danger"
                      onClick={() => handleEventAction(event.id, 'cancel')}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="quick-actions-section">
          <h2>Gestión de Calendario</h2>
          <div className="quick-actions-grid">
            <div className="quick-action-card">
              <div className="action-icon">🔗</div>
              <h3>Integraciones</h3>
              <p>Conectar con Google Calendar, Outlook, Apple</p>
              <button className="btn-primary">Configurar</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">⏰</div>
              <h3>Recordatorios</h3>
              <p>Configurar alertas y notificaciones</p>
              <button className="btn-primary">Gestionar</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">👥</div>
              <h3>Reuniones</h3>
              <p>Programar reuniones automáticamente</p>
              <button className="btn-primary">Programar</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">📊</div>
              <h3>Análisis</h3>
              <p>Estadísticas de tiempo y productividad</p>
              <button className="btn-primary">Ver Reportes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CalendarTasksPage;
